
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BladderCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Urology/BladderCancer_TNM.vue